<template>
  <div class="cfmcc-login">
    <div class="cfmcc-login__container">
      <div class="cfmcc-login__header">
        <div class="cfmcc-logo"></div>
      </div>
      <div class="cfmcc-login__body">
        <div class="cfmcc-body__wrapper">
          <div class="cfmcc-login__info">
            <div class="cfmcc-login__title">造价数据管理专家</div>
            <div class="cfmcc-login__desc">积累个人和企业造价数据库，统一管理工程项目文件，文件与团队共享协作打造多终端高效协作的造价管理平台</div>
          </div>
          <div class="cfmcc-login__box">
            <login-box reset-margin-top login-type="account" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LoginBox from '_c/PageIndex/Login/IndexNew.vue'

export default {
  name: 'cfmccLogin',
  components: {
    LoginBox
  }
}
</script>

<style lang="less" scoped>
  .cfmcc-login {
    width: 100%;
    height: 100%;
    background-image: url('~@/assets/images/cfmcc/login-bg.jpg');
    background-size: cover;
    background-position: center;
    position: relative;
    .cfmcc-login__container {
      width: 1200px;
      height: 100%;
      margin: 0 auto;
      position: relative;
      .cfmcc-login__header {
        padding-top: 33px;
      }
      .cfmcc-login__body {}
    }
    .cfmcc-logo {
      width: 208px;
      height: 19px;
      background-image: url('~@/assets/images/cfmcc/logo.png');
      background-size: cover;
      background-position: center;
    }
    .cfmcc-login__body {
      position: absolute;
      width: 100%;
      height: 470px;
      top: 50%;
      margin-top: -235px;
      .cfmcc-body__wrapper {
        position: relative;
        .cfmcc-login__box {
          position: absolute;
          width: 404px;
          height: 100%;
          top: 0;
          right: 0;
        }
      }
      .cfmcc-login__info {
        padding: 151px 140px 181px 152px;
        .cfmcc-login__title {
          height: 52px;
          font-size: 44px;
          font-family: FZZZHUNHJW--GB1-0, FZZZHUNHJW--GB1;
          font-weight: normal;
          color: #FFFFFF;
          line-height: 52px;
          letter-spacing: 2px;
        }
        .cfmcc-login__desc {
          padding-top: 22px;
          width: 504px;
          height: 64px;
          font-size: 18px;
          font-family: PingFang-SC-Regular, PingFang-SC;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 32px;
        }
      }
    }
  }
</style>
